<template>
	<div class="page">
		<!-- your page -->
		<Head></Head>
		<div class="buycar" :style="'min-height:'+clientHeight+'px;'">
			<div class="fixation">
				<div class="table" v-show="list.length!=0">
					<div class="tableHead">
						<div class="allCheck">
							<div class="checkIn" @click="selectAll">
								<img src="../../assets/cart/duigou.png" alt="" v-show="allCheck">
							</div>
							全选
						</div>
						<div class="title">
							商品
						</div>
						<div class="unit">
							单价
						</div>
						<div class="nums">
							数量
						</div>
						<div class="sums">
							小计
						</div>
						<div class="operas">
							操作
						</div>
					</div>
					<div class="tableBody">
						<div class="tableItem" v-for="item in list">
							<div class="radio">
								<div class="radioIn" :data-id="item.id" @click="cancel">
									<img src="../../assets/cart/duigou.png" alt="" v-show="item.select" :data-id="item.id">
								</div>
							</div>
							<div class="commodity">
								<div class="img">
									<img :src="item.img" alt="">
								</div>
								<div class="info">
									<div class="name">{{item.name}}</div>
									<div class="tab">{{item.tab}}</div>
								</div>
							</div>
							<div class="unitPrice">
								¥{{item.unitPrice}}
							</div>
							<div class="number">
								<div class="numberBox">
									<div class="left" @click="minus" :data-id='item.id'>
										-
									</div>
									<div class="numsBox">
										{{item.number}}
									</div>
									<div class="right" @click="add" :data-id='item.id'>
										+
									</div>
								</div>
							</div>
							<div class="price">
								¥{{item.price}}
							</div>
							<div class="operations">
								<div class="delete" :data-id="item.id" @click="deleteThis">
									删除
								</div>
							</div>
						</div>
					</div>
					<div class="tableFoot">
						<div class="clear">
							<!-- <div class="icon">
								<img src="../../assets/index/delete.png" alt="">
							</div>
							清空购物车 -->
						</div>
						<div class="allPrice">
							商品总价（不含运费和抵扣）:<span>¥{{allPrice}}</span>
						</div>
						<div class="goPay">
							<button @click="goPay">
								去结算
							</button>
						</div>
					</div>
				</div>
				<div class="clearArea" v-show="list.length==0" :style="'height:'+(clientHeight-50)+'px;'">
					<div class="clearBox">
						<img src="../../assets/cart/clearCart.png" alt="">
					</div>
					<div class="word">
						您的购物车空空如也，赶快去选购自己喜欢的东西吧！
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	// your script
	import Head from '../../components/head.vue'
	import Foot from '../../components/foot.vue'
	export default {
		name: 'cart',
		components:{
			Head,Foot
		},
		data(){
			return {
				clientHeight:0,
				list:[
					// {"id":"1","img":require("../../assets/index/commodity.jpg"),"name":"三丧的弱智打印机，复印机，内含会爆炸的三丧NOTE7，S10",tab:"套餐一:爆炸吧！NOTE7","unitPrice":123,"number":2,"price":236},
					// {"id":"1","img":require("../../assets/index/commodity.jpg"),"name":"三丧的弱智打印机，复印机，内含会爆炸的三丧NOTE7，S10",tab:"套餐一:爆炸吧！NOTE7","unitPrice":123,"number":2,"price":236},
					// {"id":"1","img":require("../../assets/index/commodity.jpg"),"name":"三丧的弱智打印机，复印机，内含会爆炸的三丧NOTE7，S10",tab:"套餐一:爆炸吧！NOTE7","unitPrice":123,"number":2,"price":236}
				],
				allPrice:"0.00",
				allCheck:true
			}
		},
		methods:{
			fetchData(){
				var token = this.token
				var data = {
					"token":token,
					"method":"cart.getlist"
				}
				this.cart(data)
			},
			cart(data){
				var that = this
				this.request(data,function(res){
					if(res.status){
						var list = res.data.list
						var arr = new Array()
						for (var i = 0; i < list.length; i++) {
							var obj = {
								"id":list[i].id,
								"img":list[i].products.image_path,
								"name":list[i].products.name,
								"tab":list[i].products.spes_desc,
								"unitPrice":list[i].products.price,
								"number":list[i].nums,
								"price":parseInt((list[i].products.price*list[i].nums)*100)/100,
								"select":list[i].is_select
							}
							arr.push(obj)
						}
						that.list = arr
						that.allPrice = res.data.amount
						that.checkAll()
					}else{
						var msg = res.msg
						that.globalTest('cart.getlist','error',msg,res.data)
					}
					that.clientHeight = `${document.documentElement.clientHeight-503}`
				})
				
			},
			checkAll(){
				var list = this.list
				var allCheck = true
				for (var i = 0; i < list.length; i++) {
					var select = list[i].select
					if(!select){
						allCheck = false
						break
					}
				}
				this.allCheck = allCheck
			},
			selectAll(){
				var allCheck = this.allCheck
				var list = this.list
				if(allCheck){
					this.allCheck=false
					for (var i = 0; i < list.length; i++) {
						list[i].select = false
					}
					this.list = list
				}else{
					this.allCheck=true
					this.allChoose()
				}
			},
			allChoose(){
				var list = this.list
				var ids = new Array()
				var token = this.token
				for (var i = 0; i < list.length; i++) {
					var lid = list[i].id
					if(i==0){
						ids+=lid
					}else{
						ids+=','+lid
					}
				}
				var data = {
					ids: ids,
					display: "all",
					token: token,
					method: "cart.getlist"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						var rList = res.data.list
						if(list.length==rList.length){
							for (var i = 0; i < rList.length; i++) {
								var rid = rList[i].id
								for (var k = 0; k < list.length; k++) {
								    var lid = list[k].id
									if(rid = lid){
										list[k].select = true
									}
								}
							}
						}else{
							var arr = new Array()
							for (var i = 0; i < rList.length; i++) {
								var obj ={
									"id":rList[i].id,
									"img":rList[i].products.image_path,
									"name":rList[i].products.name,
									"tab":rList[i].products.spes_desc,
									"unitPrice":rList[i].products.price,
									"number":rList[i].nums,
									"price":parseInt((rList[i].products.price*rList[i].nums)*100)/100,
									"select":true
								}
								arr.push(obj)
							}
							list = arr
						}
						that.list = list
					}else{
						var msg = res.msg
						that.globalTest('error',msg,res.data)
					}
				})
			},
			cancel(e){
				var id = e.target.dataset.id
				var list = this.list
				//当前的商品是否被选中
				var nowStatus
				for (var i = 0; i < list.length; i++) {
					var lid = list[i].id
					if(id==lid){
						nowStatus = list[i].select
					}
				}
				var ids = ''
				var ida = new Array()
				if(!nowStatus){
					ida.push(id)
				}
				for (var i = 0; i < list.length; i++) {
					var lid = list[i].id
					var select = list[i].select
					if(select){
						if(id!=lid){
							ida.push(list[i].id)
						}
					}
				}
				for (var i = 0; i < ida.length; i++) {
					if(i==0){
						ids+=ida[i]
					}else{
						ids+=','+ida[i]
					}
				}
				var data = {
					ids: ids,
					display: "all",
					token: this.token,
					method: "cart.getlist"
				}
				this.cart(data)
			},
			deleteThis(e){
				var id = e.target.dataset.id
				var data = {
					ids: id,
					token: this.token,
					method: "cart.del"
				}
				var that = this
				var list = this.list
				var index
				for (var i = 0; i < list.length; i++) {
					var lid = list[i].id
					if(lid == id){
						index = i
					}
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						list.splice(index,1)
						that.list = list
					}else{
						var msg = res.msg
						that.globalTest('error',msg,res.data)
					}
				})
			},
			minus(e){
				var id = e.target.dataset.id
				var ev = "minus"
				this.setNums(ev,id)
			},
			add(e){
				var id = e.target.dataset.id
				var ev = "add"
				this.setNums(ev,id)
			},
			setNums(ev,id){
				var list = this.list
				var lnum
				for (var i = 0; i < list.length; i++) {
					if(id==list[i].id){
						lnum = list[i].number
					}
				}
				if(ev=="add"){
					lnum=lnum+1
				}else{
					if(lnum>1){
						lnum=lnum-1
					}
				}
				var data = {
					id: id,
					nums: lnum,
					token: this.token,
					method: "cart.setnums"
				}
				this.cart(data)
			},
			goPay(){
				var ids = new Array()
				var list = this.list
				for (var i = 0; i < list.length; i++) {
					var select = list[i].select
					if(select){
						ids.push(list[i].id)
					}
				}
				this.$router.push({path:"/newOrder",query:{cartIds:ids.toString()}})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			var token = localStorage.getItem('token')
			this.token = token
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.buycar{
		width: 100%;
		padding-top: 50px;
		box-sizing: border-box;
	}
	.clearArea{
		width: 100%;
		padding-top: 40px;
		box-sizing: border-box;
	}
	.clearBox{
		width: 300px;
		margin: 0 auto;
	}
	.clearBox img{
		width: 100%;
		display: block;
	}
	.clearArea .word{
		width: 100%;
		height: 60px;
		text-align: center;
		line-height: 60px;
		font-size: 24px;
		color: #838383;
	}
	.table{
		width: 100%;
		border: 1px solid #B3B3B3;
		box-sizing: border-box;
	}
	.tableHead{
		width: 100%;
		height: 30px;
		background: #F0F0F0;
		line-height: 30px;
		border-bottom: 1px solid #B3B3B3;
	}
	.tableBody{
		width: 100%;
	}
	.allCheck,.radio{
		width: 99px;
		height: 100%;
		float: left;
	}
	.checkIn,.radioIn{
		width: 16px;
		height: 16px;
		border: 1px solid #B3B3B3;
		box-sizing: border-box;
		border-radius: 50%;
		float: left;
		margin-top: 7px;
		margin-left: 10px;
		background: #FFFFFF;
		margin-right: 10px;
	}
	.radioIn{
		margin-top: 50px;
	}
	.checkIn:hover,.radioIn:hover{
		cursor: pointer;
	}
	.checkIn img,.radioIn img{
		width: 100%;
		height: 100%;
		display: block;
	}
	.title,.commodity{
		width: 475px;
		height: 100%;
		float: left;
	}
	.img{
		width: 150px;
		height: 100%;
		float: left;
		padding: 5px;
		box-sizing: border-box;
	}
	.img img{
		width: 140px;
		height: 110px;
		display: block;
	}
	.info{
		width: 325px;
		height: 100%;
		float: left;
		padding: 16px auto;
	}
	.name,.tab{
		width: 100%;
		height: 50%;
		line-height: 27px;
		overflow: hidden;
	}
	.tab{
		color: #838383;
	}
	.unit,.unitPrice{
		width: 175px;
		height: 100%;
		float: left;
		text-align: center;
	}
	.unitPrice,.price{
		color: red;
	}
	.nums,.number{
		width: 175px;
		height: 100%;
		float: left;
		text-align: center;
	}
	.number{
		padding-top: 45px;
		box-sizing: border-box;
	}
	.number .numberBox{
		width: 120px;
		height: 30px;
		border: 1px solid #B3B3B3;
		box-sizing: border-box;
		margin: 0 auto;
		line-height: 30px;
	}
	.left,.right{
		width: 30px;
		height: 100%;
		float: left;
		box-sizing: border-box;
	}
	.left:hover,.right:hover{
		cursor: pointer;
	}
	.numsBox{
		width:58px;
		height: 100%;
		float: left;
	}
	.left{
		border-right: 1px solid #b3b3b3;
	}
	.right{
		border-left: 1px solid #b3b3b3;
	}
	.sums,.price{
		width: 175px;
		height: 100%;
		float: left;
		text-align: center;
	}
	.operas,.operations{
		width: 99px;
		height: 100%;
		float: left;
		text-align: center;
	}
	.delete{
		color: blue;
		width: 50px;
		height: 30px;
		line-height: 30px;
		margin: 45px auto;
	}
	.delete:hover{
		cursor: pointer;
	}
	.tableItem{
		width: 100%;
		height: 120px;
		border-bottom: 1px solid #B3B3B3;
		line-height: 120px;
	}
	.tableFoot{
		width: 100%;
		height: 50px;
		background: #F0F0F0;
		line-height: 50px;
	}
	.clear,.goPay{
		width: 199px;
		height: 100%;
		float: left;
	}
	.clear .icon{
		width: 50px;
		height: 100%;
		float: left;
	}
	.clear .icon img{
		width: 20px;
		height: 20px;
		display: block;
		margin: 15px auto;
	}
	.allPrice{
		width: 800px;
		height: 100%;
		float: left;
		text-align: right;
	}
	.allPrice span{
		color: red;
	}
	.goPay{
		padding-top: 8px;
		box-sizing: border-box;
	}
	.goPay button{
		width: 120px;
		height: 34px;
		background: #197AFF;
		color: #FFFFFF;
		border: none;
		margin: 0 auto;
		display: block;
		cursor: pointer;
	}
</style>
